/*
 *   File : create-cart-order.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description :Create card order page
 *   Integrations : null
 *   Version : v1.0
 */

// packages
import { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Modal } from "bootstrap";

// components
import { AmountInput, Datepicker, Input, SIPDateModal } from "../../components/input";
import { Toast } from "../../components/note";
import { PrimaryBtn, TextBtn } from "../../components/cta";
import { ManageAMSForm } from "../../components/modal";

// assets
import AddNew from '../../assets/images/dataFormating/add-new.svg';

// config,services
import devconfig from "../../config/config";
import APIPost from "../../services/postApi";
import APIGet from "../../services/getApi";
import { toast, ToastContainer } from "react-toastify";
import { SuccessConfirmationModal } from "../../components/modal";
import SelectBox from "../../components/dropdown/selectBox";
import moment from "moment";

const NORMALIZED_SIP_DATES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28];

const INVEST_TYPE = {
    LUMPSUM: 'lumpsum',
    SIP: 'sip',
    STP: 'stp',
    INVEST_MORE: 'invest_more'
};

const ORDER_TAB = {
    BASKET: "basket_allocation",
    AMS: "ams_allocation",
};

const DEFAULT_AMS_MIN_AMOUNT = 50000;

console.log('INVEST_TYPE', INVEST_TYPE);


const CreateCartOrder = () => {
    const navigate = useNavigate();
    const searchRef = useRef(null);
    const initialData = useRef([]);
    /* Invest More lists from /basket-order/basket-list (invest_more /
     * ams_invest_more), plus the normal AMS list so the visible Basket/AMS
     * list can swap when the invest type changes. */
    const investMoreData = useRef([]);
    const amsData = useRef([]);
    const amsInvestMoreData = useRef([]);
    const today = new Date().getDate()
    const [search, setSearch] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const [customerList, setCustomerList] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [fundsList, setFundsList] = useState([]);
    const [showDetail, setShowDetail] = useState(false);
    // const [sipChecked, setSipChecked] = useState(false);
    const [amount, setAmount] = useState("");

    const [showDateModal, setShowDateModal] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedBaskets, setSelectedBaskets] = useState([]);
    const [allocationData, setAllocationData] = useState([]);
    const [activeOrderTab, setActiveOrderTab] = useState(ORDER_TAB.BASKET);

    // AMS tab state (independent from basket tab)
    const [selectedAMS, setSelectedAMS] = useState([]);
    const [amsAllocationData, setAmsAllocationData] = useState([]);
    const [amsListLoaded, setAmsListLoaded] = useState(false);
    const [hasAmsInvestMore, setHasAmsInvestMore] = useState(false);
    const [hasBasketInvestMore, setHasBasketInvestMore] = useState(false);
    const [amsGoals, setAmsGoals] = useState([]);
    const [showAMSFormModal, setShowAMSFormModal] = useState(false);
    const [detail, setDetail] = useState({});
    const [btnLoader, setBtnLoader] = useState(false);
    const [addedFunds, setAddedFunds] = useState([]);
    const [orderSent, setOrderSent] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedFrequency, setSelectedFrequency] = useState(null);
    const [repeatedDate, setRepeatedDate] = useState(null);
    const [selectedRepeatedDate, setSelectedRepeatedDate] = useState(null);
    const [repeatedDay, setRepeatedDay] = useState(null);
    const [next30, setNext30] = useState(false);
    /* Collapse "Schedule for later" by default — most cart orders ship without
     * a schedule, so hide the inputs until the admin explicitly opens them. */
    const [scheduleExpanded, setScheduleExpanded] = useState(false);
    const [frequencyOptions, setFrequencyOptions] = useState([]);
    const [daysOptions, setDaysOptions] = useState([]);


    const [investType, setInvestType] = useState(INVEST_TYPE.LUMPSUM);
    const [stpAmount, setStpAmount] = useState('');


    const [stpWithdrawalCount, setStpWithdrawalCount] = useState(0);
    console.log('stpWithdrawalCount', stpWithdrawalCount);

    const [stpFrequency, setStpFrequency] = useState(null);
    const [stpRepeatDay, setStpRepeatDay] = useState(null);
    const [stpFrequencyOptions, setStpFrequencyOptions] = useState([]);
    console.log('stpFrequencyOptions', stpFrequencyOptions);

    const [stpRepeatDayOptions, setStpRepeatDayOptions] = useState([]);




    const [firstInvestmentNow, setFirstInvestmentNow] = useState(true);

    // Derived (keeps all existing sipChecked references working)
    const sipChecked = investType === INVEST_TYPE.SIP;
    const stpChecked = investType === INVEST_TYPE.STP;
    const isInvestMore = investType === INVEST_TYPE.INVEST_MORE;
    const selectedStpMinAmount = Math.max(
        ...selectedBaskets.map((item) =>
            stpFrequency?.value === 1
                ? Number(item.daily_minimum_amount || 0)
                : Number(item.weekly_minimum_amount || 0)
        ),
        0
    );

    console.log('stpChecked', stpChecked);

    useEffect(() => {
        window.scrollTo(0, 0);
        _getFilterData();

        if (today < 28) {
            setSelectedDate(today + 1);
        } else {
            setSelectedDate(1);
        }
        document.addEventListener('mouseup', _closeMenu);
        return () => {
            document.removeEventListener('mouseup', _closeMenu);
        };
    }, [])

    useEffect(() => {
        if (!showDetail) return;
        if (activeOrderTab !== ORDER_TAB.AMS) return;
        if (amsListLoaded) return;
        _getAMSData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showDetail, activeOrderTab, amsListLoaded]);

    useEffect(() => {
        if (activeOrderTab === ORDER_TAB.AMS && investType === INVEST_TYPE.STP) {
            setInvestType(INVEST_TYPE.LUMPSUM);
        }
    }, [activeOrderTab, investType]);

    useEffect(() => {
        if (investType !== INVEST_TYPE.INVEST_MORE) return;

        const canShowInvestMore = activeOrderTab === ORDER_TAB.BASKET
            ? hasBasketInvestMore
            : hasAmsInvestMore;

        if (!canShowInvestMore) {
            if (activeOrderTab === ORDER_TAB.AMS) {
                setInvestType(INVEST_TYPE.LUMPSUM);
                _getAMSData(amsData.current);
            } else {
                _handleChecked(INVEST_TYPE.LUMPSUM);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeOrderTab, investType, hasAmsInvestMore, hasBasketInvestMore]);

    useEffect(() => {
        if (today < 28) {
            setRepeatedDate({
                label: _formatSip(today + 1),
                value: today + 1
            });
            setSelectedRepeatedDate(today + 1)
        } else {
            setRepeatedDate({
                label: _formatSip(1),
                value: 1
            });
            setSelectedRepeatedDate(1)
        }
    }, [selectedFrequency])


    useEffect(() => {
        if (showDateModal === true) {
            const modal = new Modal(document.getElementById("sip-date"), {});
            modal.show();
        }
    }, [showDateModal]);

    useEffect(() => {
        if (orderSent === true) {
            const modal = new Modal(document.getElementById("confirmSuccess"), {});
            modal.show();
        }
    }, [orderSent]);

    useEffect(() => {
        if (showAMSFormModal === true) {
            const modal = new Modal(document.getElementById("manageAMSForm"), {});
            modal.show();
        }
    }, [showAMSFormModal]);


    const _closeMenu = (event) => {
        if (searchRef.current && !searchRef.current.contains(event.target)) {
            setShowDropdown(false);
        }
    }

    function _handleDateModal(status) {
        setShowDateModal(status)
    }

    function _handleSelect(obj, obj_index) {
        if (amount > 0) {
            const selected_baskets = [...selectedBaskets]
            const basket_data = [...allocationData]
            const index = selected_baskets.findIndex((item) => item.id === obj.id);
            if (index === -1) {
                selected_baskets.push(obj)
            } else {
                selected_baskets.splice(index, 1)
                basket_data[obj_index].allocation = 0
                basket_data[obj_index].amount = ""
            }
            setSelectedBaskets(selected_baskets)
            setAllocationData(basket_data);

        } else {
            toast.dismiss()
            toast.error("Please enter investment amount")
        }
    }



    function _handleAllocation(input_value, id, obj_index) {
        const selected_baskets = [...selectedBaskets]
        const basket_data = [...allocationData]
        const index = selected_baskets.findIndex((item) => item.id === id);
        if (input_value <= 100) {
            selected_baskets[index].allocation = input_value;
            basket_data[obj_index].allocation = input_value;
            selected_baskets[index].amount = ((input_value / 100) * amount)
            basket_data[obj_index].amount = ((input_value / 100) * amount)
        }
        setSelectedBaskets(selected_baskets)
        setAllocationData(basket_data);
    }

    // function _handleSip(input_value, id, obj_index, min) {
    //     const selected_baskets = [...selectedBaskets]
    //     const basket_data = [...allocationData]
    //     const index = selected_baskets.findIndex((item) => item.id === id);
    //     selected_baskets[index].amount = input_value
    //     basket_data[obj_index].amount = input_value;
    //     setSelectedBaskets(selected_baskets)
    //     setAllocationData(basket_data);
    // }

    function _handleBasketAmount(input_value, id, obj_index, min) {
        const selected_baskets = [...selectedBaskets]
        const basket_data = [...allocationData]
        const index = selected_baskets.findIndex((item) => item.id === id);
        if (input_value <= amount) {
            selected_baskets[index].amount = input_value;
            basket_data[obj_index].amount = input_value;
            selected_baskets[index].allocation = input_value > 0 ? (parseFloat((input_value / amount) * 100)).toFixed(2) : 0
            basket_data[obj_index].allocation = input_value > 0 ? (parseFloat((input_value / amount) * 100)).toFixed(2) : 0
        }
        setSelectedBaskets(selected_baskets)
        setAllocationData(basket_data);
    }

    // ── AMS TAB ──
    const _getAMSData = (rows = null) => {
        // An explicit list (even empty) reflects the API exactly. Invest More
        // uses ams_invest_more, which is empty when the customer has no AMS to
        // top up, so don't substitute placeholder data in that case.
        if (Array.isArray(rows)) {
            const mapped = rows.map((item) => ({
                ams: item.name,
                allocation: 0,
                amount: "",
                id: item.id,
                ...item,
            }));
            setAmsAllocationData(mapped);
            setAmsListLoaded(true);
            return;
        }

        // No list passed (e.g. AMS tab opened before basket-list loaded) —
        // legacy Figma sample fallback.
        const fallback = [
            { id: 1, ams: "High growth active funds" },
            { id: 2, ams: "Sector rotation" },
            { id: 3, ams: "High growth index funds" },
            { id: 4, ams: "Moderate growth" },
        ].map((item) => ({ ...item, allocation: 0, amount: "" }));
        setAmsAllocationData(fallback);
        setAmsListLoaded(true);
    };

    const _getAMSGoalFilter = () => {
        const url = devconfig.admin + "/ams/filter";
        return APIGet(url).then((response) => {
            if (response?.status_code === 200 || response?.status === true) {
                setAmsGoals(Array.isArray(response.data) ? response.data : []);
                return true;
            }
            const msg = response?.message || "Failed to load AMS goals";
            toast.dismiss();
            toast.error(msg);
            return Promise.reject(msg);
        }).catch(() => {
            const msg = "Failed to load AMS goals";
            toast.dismiss();
            toast.error(msg);
            return Promise.reject(msg);
        });
    };

    const _openCreateAMSModal = () => {
        if (amsGoals.length > 0) {
            setShowAMSFormModal(true);
            return;
        }
        _getAMSGoalFilter().then(() => {
            setShowAMSFormModal(true);
        });
    };

    const _handleAMSFormSubmit = (payload) => {
        const url = devconfig.admin + "/ams/upsert";
        const body = JSON.stringify({
            id: null,
            name: payload.name,
            home_page_visibility: false,
            ams_alias: payload.ams_alias,
            allocations: payload.allocations,
            min_sip: payload.min_sip,
            min_lumpsum: payload.min_lumpsum,
        });

        return APIPost(url, body).then((response) => {
            if (response?.status_code === 200 || response?.status === true) {
                document.getElementById("ams-form-dismiss")?.click();
                toast.dismiss();
                toast.success("AMS Created Successfully");
                if (selectedCustomer?.id) {
                    _getBasketData(selectedCustomer.id, false);
                }
            } else {
                const msg = response?.message || "Failed to save AMS";
                return Promise.reject(msg);
            }
        }).catch((errMsg) => {
            const msg = typeof errMsg === "string" ? errMsg : "Failed to save AMS";
            return Promise.reject(msg);
        });
    };

    function _handleSelectAMS(obj, obj_index) {
        if (amount > 0) {
            const selected_ams = [...selectedAMS];
            const ams_data = [...amsAllocationData];
            const index = selected_ams.findIndex((item) => item.id === obj.id);
            if (index === -1) {
                selected_ams.push(obj);
            } else {
                selected_ams.splice(index, 1);
                ams_data[obj_index].allocation = 0;
                ams_data[obj_index].amount = "";
            }
            setSelectedAMS(selected_ams);
            setAmsAllocationData(ams_data);
        } else {
            toast.dismiss();
            toast.error("Please enter investment amount");
        }
    }

    function _handleAMSAllocation(input_value, id, obj_index) {
        const selected_ams = [...selectedAMS];
        const ams_data = [...amsAllocationData];
        const index = selected_ams.findIndex((item) => item.id === id);
        if (index === -1) return;
        if (input_value <= 100) {
            selected_ams[index].allocation = input_value;
            ams_data[obj_index].allocation = input_value;
            selected_ams[index].amount = ((input_value / 100) * amount)
            ams_data[obj_index].amount = ((input_value / 100) * amount)
        }
        setSelectedAMS(selected_ams);
        setAmsAllocationData(ams_data);
    }

    function _handleAMSAmount(input_value, id, obj_index) {
        const selected_ams = [...selectedAMS];
        const ams_data = [...amsAllocationData];
        const index = selected_ams.findIndex((item) => item.id === id);
        if (index === -1) return;
        if (input_value <= amount) {
            selected_ams[index].amount = input_value;
            ams_data[obj_index].amount = input_value;
            selected_ams[index].allocation = input_value > 0 ? (parseFloat((input_value / amount) * 100)).toFixed(2) : 0
            ams_data[obj_index].allocation = input_value > 0 ? (parseFloat((input_value / amount) * 100)).toFixed(2) : 0
        }
        setSelectedAMS(selected_ams);
        setAmsAllocationData(ams_data);
    }

    // handle sip date
    function _handleSelectDate(date) {
        setSelectedDate(date);
    }

    function _handleFundSelect(value, index, code, obj) {
        const funds = [...addedFunds]
        funds[index].scheme_name = value;
        funds[index].scheme_code = code;
        funds[index].min_lumpsum_investment = obj.min_lumpsum_investment
        funds[index].min_sip_investment = obj.min_sip_investment
        funds[index].allocation = 0
        funds[index].amount = ""
        setAddedFunds(funds)
    }

    function _handleFundAllocation(value, index,) {
        const funds = [...addedFunds]
        if (value <= 100) {
            funds[index].allocation = value;
            if (sipChecked) {
                funds[index].amount = ((value / 100) * amount)
            } else {
                funds[index].amount = ((value / 100) * amount)
            }
        }
        setAddedFunds(funds)
    }

    function _handleFundAmount(value, index, code) {
        const funds = [...addedFunds]
        if (value <= amount) {
            funds[index].amount = value;
            funds[index].allocation = value > 0 ? (parseFloat((value / amount) * 100)).toFixed(2) : 0

        }
        setAddedFunds(funds)
    }



    function _handleAdd() {
        if (amount > 0) {
            const funds = [...addedFunds]

            funds.push({
                scheme_name: "",
                scheme_code: "",
                allocation: 0,
                min_lumpsum_investment: "",
                min_sip_investment: "",
                amount: ""
            })
            setAddedFunds(funds)
        } else {
            toast.dismiss();
            toast.error("Please enter investment amount");
        }
    }

    function _getTotalAllocation() {
        const sum1 = selectedBaskets.reduce((a, b) => a + parseFloat(b.allocation), 0);
        const sum2 = addedFunds.reduce((a, b) => a + parseFloat(b.allocation), 0);
        return parseFloat(sum1) + parseFloat(sum2)
    }

    function _getTotalAmount(type) {
        console.log(selectedBaskets)
        const sum1 = selectedBaskets.filter((basket) => basket.amount > 0).reduce((a, b) => (a) + (b.amount), 0);
        const sum2 = addedFunds.filter((fund) => fund.amount > 0).reduce((a, b) => (a) + (b.amount), 0);
        let finalSum = parseFloat(sum1 ? sum1 : 0) + parseFloat(sum2 ? sum2 : 0);

        if (type === 1) {
            return finalSum.toLocaleString('en-IN')
        } else {
            return finalSum
        }

    }

    function _getAMSTotalAllocation() {
        const sum = selectedAMS.reduce((a, b) => a + parseFloat(b.allocation), 0);
        return parseFloat(sum || 0);
    }

    function _getAMSTotalAmount(type) {
        const sum = selectedAMS.filter((ams) => ams.amount > 0).reduce((a, b) => a + (b.amount), 0);
        const finalSum = parseFloat(sum || 0);
        return type === 1 ? finalSum.toLocaleString('en-IN') : finalSum;
    }


    function _handleSubmit() {
        toast.dismiss();

        if (activeOrderTab === ORDER_TAB.AMS) {
            if (amount === "" || amount < 0) {
                toast.error(`Please enter investment amount`);
                return false;
            }

            if (selectedAMS.length === 0) {
                toast.error(`Please select at least one AMS`);
                return false;
            }

            for (let i = 0; i < selectedAMS.length; i++) {
                const element = selectedAMS[i];
                if (sipChecked) {
                    // const minAmsAmount = firstInvestmentNow
                    //     ? (element.min_lumpsum_amount || DEFAULT_AMS_MIN_AMOUNT)
                    //     : (element.min_sip_amount || DEFAULT_AMS_MIN_AMOUNT);
                    const minAmsAmount = element.min_sip_amount || DEFAULT_AMS_MIN_AMOUNT;
                    if (element.amount < minAmsAmount) {
                        toast.error(`${element.ams}'s SIP cannot be less than the minimum amount of ₹${minAmsAmount.toLocaleString('en-IN')}`);
                        return false;
                    }
                } else {
                    const minAmsLumpsum = element.min_lumpsum_amount || DEFAULT_AMS_MIN_AMOUNT;
                    if (element.amount < minAmsLumpsum) {
                        toast.error(`${element.ams}'s Lumpsum cannot be less than the minimum amount of ₹${minAmsLumpsum.toLocaleString('en-IN')}`);
                        return false;
                    }
                }
            }

            if (_getAMSTotalAllocation() !== 100) {
                toast.error(`Total allocation must be 100%`);
                return false;
            }
            if (_getAMSTotalAmount(2) !== amount) {
                toast.error(`Total allocated amount is not matching with Invested amount`);
                return false;
            }

            const isAnyFilled = startDate || endDate || selectedFrequency;
            const isAllFilled = startDate && endDate && selectedFrequency;

            if (isAnyFilled && !isAllFilled) {
                toast.error(`Scheduled orders need start date, end date, and repeat frequency`);
                return false;
            }
            if (selectedFrequency !== null && (selectedFrequency?.value === 2 || selectedFrequency?.value === 3) && repeatedDay === null) {
                toast.error(`Please select repeating day for requency`);
                return false;
            }

            _createOrder();
            return;
        }

        const selected_baskets = [...selectedBaskets]

        if (sipChecked) {
            if (amount === "" || amount < 0) {
                toast.error(`Please enter investment amount`);
                return false;
            }
        } else {
            if (amount === "" || amount < 0) {
                toast.error(`Please enter investment amount`);
                return false;
            }
        }

        if (selectedBaskets.length > 0) {
            for (let i = 0; i < selected_baskets.length; i++) {
                const element = selected_baskets[i];
                if (sipChecked) {
                    if (element.amount < element.min_sip_amount) {
                        toast.error(`${element.basket}'s SIP cannot be less than the minimum amount of ₹${element.min_sip_amount.toLocaleString('en-IN')}`);
                        return false;
                    }
                } else if (stpChecked) {
                    if (element.amount < element.daily_stp_amount) {
                        toast.error(`${element.basket}'s STP cannot be less than the minimum amount of ₹${element.daily_stp_amount.toLocaleString('en-IN')}`);
                        return false;
                    }
                }
                else {
                    if (element.amount < element.min_lumpsum_amount) {
                        console.log('element', element)
                        toast.error(`${element.basket}'s Lumpsum cannot be less than the minimum amount of ₹${element.min_lumpsum_amount.toLocaleString('en-IN')}`);
                        return false;
                    }
                }
            }
        }
        if (addedFunds.length > 0) {
            for (let i = 0; i < addedFunds.length; i++) {
                const element = addedFunds[i];
                if (sipChecked) {
                    if (element.scheme_code === "") {
                        toast.error(`Please select a fund to proceed with SIP`);
                        return false;
                    }
                    if (element.amount < element.min_sip_investment) {
                        toast.error(`${element.scheme_name}'s SIP cannot be less than the minimum amount of ₹${element.min_sip_investment.toLocaleString('en-IN')}`);
                        return false;
                    }
                } else {
                    if (element.scheme_code === "") {
                        toast.error(`Please select a fund to proceed with Lumpsum`);
                        return false;
                    }
                    if (element.amount < element.min_lumpsum_investment) {
                        toast.error(`${element.scheme_name}'s Lumpsum cannot be less than the minimum amount of ₹${element.min_lumpsum_investment.toLocaleString('en-IN')}`);
                        return false;
                    }
                }

            }
        }
        if (_getTotalAllocation() !== 100) {
            toast.error(`Total allocation must be 100%`);
            return false;
        }
        console.log('_getTotalAmount(2)', _getTotalAmount(2), amount)
        if (_getTotalAmount(2) !== amount) {
            toast.error(`Total allocated amount is not matching with Invested amount`);
            return false;
        }
        const isAnyFilled = startDate || endDate || selectedFrequency;
        const isAllFilled = startDate && endDate && selectedFrequency;

        if (isAnyFilled && !isAllFilled) {
            toast.error(`Scheduled orders need start date, end date, and repeat frequency`);
            return false;
        }
        if (selectedFrequency !== null && (selectedFrequency?.value === 2 || selectedFrequency?.value === 3) && repeatedDay === null) {
            toast.error(`Please select repeating day for requency`);
            return false;
        }

        if (stpChecked) {
            if (!stpAmount || parseFloat(stpAmount) <= 0) {
                toast.error(`Please enter STP amount`);
                return false;
            }

            if (selectedStpMinAmount > 0 && parseFloat(stpAmount) < selectedStpMinAmount) {
                toast.error(`Minimum STP amount is ₹${selectedStpMinAmount}`);
                return false;
            }

            if (!stpFrequency) {
                toast.error(`Please select STP repeat frequency`);
                return false;
            }
            if (stpFrequency?.value === 2 && !stpRepeatDay) {
                toast.error(`Please select a repeat day for weekly STP`);
                return false;
            }
        }

        if (stpFrequency?.value === 1) {
            // DAILY
            const minDays = Math.max(
                ...selectedBaskets.map(item => item.daily_minimum_installment || 0)
            );
            if (stpWithdrawalCount < minDays) {
                toast.error(`Minimum ${minDays} days required for transfer`);
                return false;
            }
        }

        if (stpFrequency?.value === 2) {
            // WEEKLY
            const minWeeks = Math.max(
                ...selectedBaskets.map(item => item.weekly_minimum_installment || 0)
            );
            if (stpWithdrawalCount < minWeeks) {
                toast.error(`Minimum ${minWeeks} weeks required for transfer`);
                return false;
            }
        }

        _createOrder();
    }

    // function _handleChecked(status) {
    //     // _getBasketData(detail.id)
    //     setSipChecked(status);
    //     // let added_funds = [...addedFunds]
    //     // if (status) {
    //     //     setAmount(amount);
    //     // } else {
    //     //     setAmount(amount);
    //     // }
    //     // if (added_funds.length > 0) {
    //     //     added_funds.map((element) => {
    //     //         element.scheme_name = ""
    //     //         element.scheme_code = ""
    //     //         element.allocation = 0
    //     //         element.sip = ""
    //     //         element.min_lumpsum_investment = ""
    //     //         element.min_sip_investment = ""
    //     //         element.amount = ""
    //     //     })
    //     //     setAddedFunds(added_funds)
    //     // }
    // }

    // function _handleChecked(type) {
    //     setInvestType(type);
    //     if (type !== INVEST_TYPE.STP) {
    //         setStpAmount('');
    //         setStpWithdrawalCount(0);

    //         setStpFrequency(null);
    //         setStpRepeatDay(null);
    //     }

    //     if (type === INVEST_TYPE.STP) {
    //         setSelectedBaskets((prev) => prev.filter((item) => item.stp_enable));
    //     }
    // }

    function _handleChecked(type) {

        const prevInvestMore = investType === INVEST_TYPE.INVEST_MORE;
        const nextInvestMore = type === INVEST_TYPE.INVEST_MORE;

        setInvestType(type);

        // The AMS list source swaps between the normal and Invest More lists
        // when entering/leaving Invest More.
        if (prevInvestMore !== nextInvestMore) {
            const amsSource = nextInvestMore ? amsInvestMoreData.current : amsData.current;
            setAmsAllocationData((amsSource || []).map(item => ({
                ams: item.name,
                allocation: 0,
                amount: "",
                id: item.id,
                ...item
            })));
            setSelectedAMS([]);
        }

        // Preserve amount, basket/AMS/fund selections and their allocations on every type switch.
        // Only STP requires filtering baskets to stp_enable=true; selections that don't qualify
        // for STP are dropped, but matching ones keep their allocation/amount.
        // setSelectedBaskets([]);
        // setSelectedAMS([]);
        // setAddedFunds([]);
        // setAmount(0);
        // setAmsAllocationData((prev) => prev.map((item) => ({
        //     ...item,
        //     allocation: 0,
        //     amount: ""
        // })));

        if (type !== INVEST_TYPE.STP) {
            setStpAmount('');
            setStpWithdrawalCount(0);
            setStpFrequency(null);
            setStpRepeatDay(null);
        }

        if (type === INVEST_TYPE.STP) {
            // Drop selections that aren't STP-enabled; keep allocation/amount on the rest
            const stpEnabledIds = new Set(
                initialData.current.filter(item => item.stp_enable === true).map(item => item.id)
            );
            const filteredSelections = selectedBaskets.filter(b => stpEnabledIds.has(b.id));
            setSelectedBaskets(filteredSelections);

            // Build the visible basket list (STP-enabled only), carrying over allocation/amount
            // from current selections so user input survives the switch.
            const stpBaskets = initialData.current
                .filter(item => item.stp_enable === true)
                .map(item => {
                    const selected = filteredSelections.find(b => b.id === item.id);
                    return {
                        ...item,
                        allocation: selected ? selected.allocation : 0,
                        amount: selected ? selected.amount : ''
                    };
                });
            setAllocationData(stpBaskets);

            // STP recurring config: derive from the user's current amount (no prefill overwrite).
            const firstItem = initialData.current[0];
            if (!firstItem) return;

            const isDaily = stpFrequency?.value === 1;
            const minCount = Math.max(
                ...initialData.current.map(item =>
                    isDaily
                        ? (item.daily_minimum_installment || 0)
                        : (item.weekly_minimum_installment || 0)
                )
            );

            // const prefillAmount = isDaily
            //     ? firstItem.daily_stp_amount
            //     : firstItem.weekly_stp_amount;
            // if (prefillAmount > 0) {
            //     setAmount(prefillAmount);
            //     setStpWithdrawalCount(minCount);
            //     if (minCount > 0) {
            //         setStpAmount((prefillAmount / minCount).toFixed(2));
            //     }
            // }

            if (amount > 0 && minCount > 0) {
                setStpWithdrawalCount(minCount);
                setStpAmount((amount / minCount).toFixed(2));
            }

        } else {
            // LUMPSUM / SIP / INVEST_MORE — the visible basket list depends on
            // the type (Invest More has its own list). Preserve allocation/amount
            // for selections still present in the new list; drop the rest.
            const sourceBaskets = type === INVEST_TYPE.INVEST_MORE
                ? investMoreData.current
                : initialData.current;
            const visibleIds = new Set(sourceBaskets.map(b => b.id));
            const filteredSelections = selectedBaskets.filter(b => visibleIds.has(b.id));
            setSelectedBaskets(filteredSelections);
            setAllocationData(sourceBaskets.map(item => {
                const selected = filteredSelections.find(b => b.id === item.id);
                return {
                    ...item,
                    allocation: selected ? selected.allocation : 0,
                    amount: selected ? selected.amount : ''
                };
            }));
        }
    }

    function _selectCustomer(item) {
        setSelectedCustomer(item);
        setShowDropdown(false);
        _getBasketData(item.id, true);
    }

    function _showSuccessModal(status) {
        setOrderSent(status)
    }

    function _handleAmount(input_value) {
        setAmount(input_value);

        if (!input_value || input_value <= 0) {
            setSelectedBaskets([]);
            setSelectedAMS([]);
            const resetData = allocationData.map(item => ({
                ...item,
                allocation: 0,
                amount: ""
            }));
            setAllocationData(resetData);
            setAmsAllocationData((prev) => prev.map((item) => ({
                ...item,
                allocation: 0,
                amount: ""
            })));
            return;
        }

        // Update allocation amounts
        // const updatedAllocations = allocationData.map(item => {
        //     const amt = (input_value * item.allocation) / 100;
        //     return {
        //         ...item,
        //         amount: item.allocation > 0 ? amt.toFixed(2) : '',
        //     };
        // });

        // Always derive from selectedBaskets
        const updatedAllocations = allocationData.map(item => {
            const selected = selectedBaskets.find(b => b.id === item.id);

            const allocation = selected ? selected.allocation : item.allocation;
            const amt = (input_value * allocation) / 100;

            return {
                ...item,
                allocation: allocation,
                amount: allocation > 0 ? Number(amt.toFixed(2)) : ''
            };
        });

        // if (selectedBaskets.length) {
        //     const basket = selectedBaskets.map((item, key) => {
        //         if (item.id === allocationData[key]?.id) {
        //             const amt = (input_value * item.allocation) / 100;
        //             return { ...item, amount: item.allocation > 0 ? amt : '' };
        //         }
        //         return item;
        //     });
        //     setSelectedBaskets(basket);
        // }

        if (selectedBaskets.length) {
            const basket = selectedBaskets.map((item) => {
                const amt = (input_value * item.allocation) / 100;

                return {
                    ...item,
                    amount: item.allocation > 0 ? Number(amt.toFixed(2)) : ''
                };
            });

            setSelectedBaskets(basket);
        }

        if (selectedAMS.length) {
            const ams = selectedAMS.map((item) => {
                const amt = (input_value * item.allocation) / 100;
                return {
                    ...item,
                    amount: item.allocation > 0 ? Number(amt.toFixed(2)) : ''
                };
            });

            setSelectedAMS(ams);
        }

        setAmsAllocationData((prev) => prev.map((item) => {
            const selected = selectedAMS.find(a => a.id === item.id);
            const allocation = selected ? selected.allocation : item.allocation;
            const amt = (input_value * allocation) / 100;
            return {
                ...item,
                allocation: allocation,
                amount: allocation > 0 ? Number(amt.toFixed(2)) : ''
            };
        }));

        setAllocationData(updatedAllocations);

        // ── STP ONLY: inline recalc to avoid stale closure ──
        // if (stpChecked && stpFrequency) {
        //     if (stpFrequency.value === 1) {
        //         if (stpAmount > 0) {
        //             const days = Math.floor(input_value / stpAmount);
        //             if (days > 0) {
        //                 setStpWithdrawalCount(days);
        //             } else {
        //                 setStpWithdrawalCount(0);
        //             }
        //         }
        //     }

        //     if (stpFrequency.value === 2) {
        //         if (stpAmount > 0) {
        //             const weeks = Math.floor(input_value / stpAmount);
        //             if (weeks > 0) {
        //                 setStpWithdrawalCount(weeks);
        //             } else {
        //                 setStpWithdrawalCount(0);
        //             }
        //         }
        //     }
        // }

        // ── STP ONLY: inline recalc to avoid stale closure ──
        if (stpChecked && stpFrequency) {
            const count = parseInt(stpWithdrawalCount) || 0;

            if (stpFrequency.value === 1 || stpFrequency.value === 2) {
                if (count > 0 && input_value > 0) {
                    // Days/Weeks stays fixed → recalculate the per-installment amount
                    setStpAmount((input_value / count).toFixed(2));
                } else {
                    setStpAmount('');
                }
            }
        }
    }


    function _handleDelete(index) {
        const added_funds = [...addedFunds]
        added_funds.splice(index, 1);
        setAddedFunds(added_funds)
    }

    function _handleClose() {
        setOrderSent(false);
        setShowDetail(false);
        setSelectedBaskets([]);
        setSelectedAMS([]);
        setAmsAllocationData([]);
        setAmsListLoaded(false);
        setHasAmsInvestMore(false);
        setHasBasketInvestMore(false);
        setAddedFunds([]);
        setOrderSent(false);
        window.scrollTo(0, 0);
        setSelectedCustomer(null);
        setAmount(0);
        // setSipChecked(false);
        setInvestType(INVEST_TYPE.LUMPSUM);
        setStpAmount('');
        setStpWithdrawalCount(0);

        setStpFrequency(null);
        setStpRepeatDay(null);
        if (today < 28) {
            setSelectedDate(today + 1);
        } else {
            setSelectedDate(1);
        }
        setSelectedFrequency(null);
        setStartDate(null);
        setEndDate(null);
        setRepeatedDay(null);
        setNext30(false);
        setActiveOrderTab(ORDER_TAB.BASKET);
    }

    function _viewOrders() {

        if (investType === INVEST_TYPE.INVEST_MORE) {
            navigate("/pending-orders", {
                state: {
                    index: 3,
                }
            });
            return;
        }

        if (stpChecked) {
            navigate("/pending-orders", {
                state: {
                    index: 2,
                    // type: 5
                }
            });
            return;
        }

        if (startDate !== null && endDate !== null && investType === INVEST_TYPE.LUMPSUM) {
            navigate(-1);
        } else {
            navigate("/pending-orders", {
                state: {
                    index: 2
                }
            });
        }
    }

    // function _handleBack() {
    //     setShowDetail(false);
    //     setSelectedCustomer(null);
    //     setAmount(0);
    //     setAmount(0);
    //     setSipChecked(false);
    //     if (today < 28) {
    //         setSelectedDate(today + 1);
    //     } else {
    //         setSelectedDate(1);
    //     }
    // }

    function _handleBack() {
        setShowDetail(false);
        setSelectedCustomer(null);
        setAmount(0);
        setInvestType(INVEST_TYPE.LUMPSUM);  // replaces setSipChecked(false)
        if (today < 28) {
            setSelectedDate(today + 1);
        } else {
            setSelectedDate(1);
        }
        // ADD STP resets
        setStpAmount('');
        setStpWithdrawalCount(0);

        setStpFrequency(null);
        setStpRepeatDay(null);

        setActiveOrderTab(ORDER_TAB.BASKET);
        setSelectedAMS([]);
        setAmsAllocationData([]);
        setAmsListLoaded(false);
        setHasAmsInvestMore(false);
        setHasBasketInvestMore(false);
    }

    function getMinAmount(item) {
        if (stpChecked) return item.daily_stp_amount;
        if (sipChecked) return item.min_sip_amount;
        return item.min_lumpsum_amount;
    }

    function getAMSMinAmount(item) {
        if (sipChecked) {
            // return firstInvestmentNow
            //     ? (item.min_lumpsum_amount || DEFAULT_AMS_MIN_AMOUNT)
            //     : (item.min_sip_amount || DEFAULT_AMS_MIN_AMOUNT);
            return item.min_sip_amount || DEFAULT_AMS_MIN_AMOUNT;
        }
        return item.min_lumpsum_amount || DEFAULT_AMS_MIN_AMOUNT;
    }

    function _clearAll() {
        if (activeOrderTab === ORDER_TAB.BASKET) {
            setSelectedBaskets([]);
            setAddedFunds([]);
            setAmount(0);
            _getBasketData(detail.id, false);
            return;
        }

        setSelectedAMS([]);
        setAmount(0);
        setAmsAllocationData((prev) => prev.map((item) => ({
            ...item,
            allocation: 0,
            amount: ""
        })));
    }


    const _formatSip = (selected_date) => {
        switch (selected_date) {
            case 1: return "1st of every month";
            case 2: return "2nd of every month";
            case 3: return "3rd of every month";
            case 21: return "21st of every month";
            case 22: return "22nd of every month";
            case 23: return "23rd of every month";
            default: return selected_date + "th of every month";
        };
    }

    // API - customer list
    const _getCustomerFilterData = (query = null) => {
        setSelectedCustomer(null);
        let api_url = devconfig.admin + '/basket-order/customer-filter-data';
        let data = JSON.stringify({
            query: query
        });
        APIPost(api_url, data).then((response) => {
            if (response.status_code === 200) {
                setShowDropdown(true);
                setCustomerList(response.data);
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
        });
    }

    // API - fund list
    const _getFunds = (query = null, index) => {
        let api_url = devconfig.admin + '/fund/v2/search';
        let sample_query = query.length > 0 ? query.replace(/\s*-\s*/g, " ") : ""
        let data = JSON.stringify({
            query: sample_query.toLowerCase().trim(),
            page_num: 1,
        });
        APIPost(api_url, data).then((response) => {
            if (response.status_code === 200) {
                setShowDropdown(index);
                setFundsList(response.data);
            } else {
                toast.dismiss();
                toast.error(response.message);
                setShowDropdown(null);
                setFundsList([]);
            }
        });
    }

    // API - fund detail
    const _getFundDetail = (fund, index) => {
        let api_url = devconfig.admin + '/fund/custom-fund';
        let data = JSON.stringify({
            isin: fund.isin
        });
        APIPost(api_url, data).then((response) => {
            if (response.status_code === 200) {
                _handleFundSelect(fund.scheme_name, index, fund.scheme_code, fund)
                setShowDropdown(false);
            } else {
                _handleFundSelect("", index, "", fund)
                toast.dismiss();
                toast.error(response.message);
            }
        });
    }

    // API - get user details
    const _getDetail = (temp) => {
        let url = devconfig.admin + '/basket-order/customer-detail';
        let data = JSON.stringify({
            "customer_id": parseInt(temp),
        })
        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                let detail = {
                    id: temp,
                    ...response.data
                }
                setDetail(detail);
                setShowDetail(true);
            }
            else {
                setDetail({})
            }
        })
    }

    const disabledDate = (current) => {
        // Disable today and any day before today
        return current && current.isBefore(moment().startOf('day').add(1, 'days'));
    };


    function _isBasketDisabled(item) {
        if (stpChecked) return item.stp_funds_added === false;
        if (sipChecked) return item.sip_funds_added === false;
        return item.lumpsum_funds_added === false;
    }

    function _getBasketDisabledMsg(item) {
        if (stpChecked) return item.stp_disbled_msg || "Disabled for STP";   // note typo: disbled
        if (sipChecked) return item.sip_disbled_msg || "Disabled for SIP";   // note typo: disbled
        return item.lumpsum_disbled_msg || "Disabled for Lumpsum";           // note typo: disbled
    }

    // API - create basket order 
    const _createOrder = () => {
        setBtnLoader(true);
        let api_url = devconfig.admin + '/basket-order/set';
        const isAMSTab = activeOrderTab === ORDER_TAB.AMS;

        const basket_data = selectedBaskets.map((item) => {

            return ({
                "goal_id": item.id,
                "lumpsum": investType === INVEST_TYPE.LUMPSUM ? {
                    "amount": item.amount,
                } : null,
                "sip": sipChecked === true ? {
                    "amount": item.amount,
                    "sip_date": selectedDate,
                    "get_first_installment": firstInvestmentNow
                } : null,
                "stp": stpChecked === true ? {
                    "amount": item.amount,
                    "frequency": stpFrequency?.value,
                    "stp_amount": parseFloat(stpAmount),
                    "stp_days": stpFrequency?.value === 1 ? parseInt(stpWithdrawalCount) : null,
                    "repeat_day": stpFrequency?.value === 2 ? stpRepeatDay?.value : null
                } : null
            })
        })

        const custom_funds = addedFunds.map((item) => {
            return ({
                "scheme_code": item.scheme_code,
                "lumpsum": investType === INVEST_TYPE.LUMPSUM ? {
                    "amount": item.amount
                } : null,
                "sip": sipChecked === true ? {
                    "amount": item.amount,
                    "sip_date": selectedDate,
                    "get_first_installment": firstInvestmentNow
                } : null,
                stp: stpChecked === true ? {
                    amount: item.amount,
                    frequency: stpFrequency?.value,
                    stp_amount: parseFloat(stpAmount),
                    stp_days: stpFrequency?.value === 1 ? parseInt(stpWithdrawalCount) : null,
                    repeat_day: stpFrequency?.value === 2 ? stpRepeatDay?.value : null
                } : null
            })
        })

        const ams_data = selectedAMS.map((item) => ({
            "ams_id": item.id,
            "lumpsum": investType === INVEST_TYPE.LUMPSUM ? {
                "amount": item.amount,
            } : null,
            "sip": sipChecked === true ? {
                "amount": item.amount,
                "sip_date": selectedDate,
                "get_first_installment": firstInvestmentNow
            } : null
        }));

        console.log(endDate)

        const isInvestMore = investType === INVEST_TYPE.INVEST_MORE;
        /* Invest More sends a single flat list with an is_ams flag per item,
         * sourced from the active tab's selection. */
        const invest_more_data = isInvestMore
            ? (isAMSTab
                ? selectedAMS.map((item) => ({ "goal_id": item.id, "amount": item.amount, "is_ams": true }))
                : selectedBaskets.map((item) => ({ "goal_id": item.id, "amount": item.amount, "is_ams": false })))
            : [];

        let data = JSON.stringify({
            "customer_id": selectedCustomer.id,
            "baskets": (isAMSTab || isInvestMore) ? null : (basket_data.length === 0 ? null : basket_data),
            "funds": (isAMSTab || isInvestMore) ? null : (custom_funds.length === 0 ? null : custom_funds),
            "ams": (isAMSTab && !isInvestMore) ? (ams_data.length === 0 ? null : ams_data) : null,
            "invest_more": isInvestMore ? (invest_more_data.length === 0 ? null : invest_more_data) : null,
            "schedule_cart_order": (startDate !== null && endDate !== null && selectedFrequency !== null) ? {
                "start_date": startDate,
                "end_date": endDate,
                "frequency": selectedFrequency?.value,
                "repeat_date": (selectedFrequency?.value === 4) ? repeatedDate?.value : null,
                "repeat_day": (selectedFrequency?.value === 2 || selectedFrequency?.value === 3) ? repeatedDay?.value : null
            } : null
        })
        APIPost(api_url, data).then((response) => {
            toast.dismiss();
            if (response.status_code === 200) {
                setBtnLoader(false);
                _showSuccessModal(true)
            } else {
                toast.error(response.message);
            }
            setBtnLoader(false);
        })
    }

    // API - get basket data
    const _getBasketData = (id, is_first) => {
        setSelectedBaskets([]);
        setSelectedAMS([]);
        const url = devconfig.admin + "/basket-order/basket-list";
        let data = JSON.stringify({
            "customer_id": parseInt(id),
        })
        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {

                if (response.data?.invest_type) {
                    setStpFrequencyOptions(
                        response.data.invest_type.map((item) => ({
                            label: item.display_name,
                            value: item.id
                        }))
                    );
                }

                if (response.data?.repeat_day) {
                    setStpRepeatDayOptions(
                        response.data.repeat_day.map((item) => ({
                            label: item.display_name,
                            value: item.id
                        }))
                    );
                }

                // Store both AMS lists (normal + Invest More) so switching the
                // invest type can swap the visible AMS list.
                amsData.current = Array.isArray(response.data?.ams_data) ? response.data.ams_data : [];
                amsInvestMoreData.current = Array.isArray(response.data?.ams_invest_more) ? response.data.ams_invest_more : [];
                setHasAmsInvestMore(amsInvestMoreData.current.length > 0);
                _getAMSData(investType === INVEST_TYPE.INVEST_MORE ? amsInvestMoreData.current : amsData.current);



                if (is_first) {
                    _getDetail(id);
                }
                const basket_list = response.data.basket_data.map((item) => {
                    // const percent = (((checked ? item.min_sip_amount : item.min_lumpsum_amount) / (checked ? amount : amount)) * 100)
                    return ({
                        basket: item.goal_name,
                        allocation: 0,
                        amount: "",
                        id: item.id,
                        ...item
                    })
                })
                initialData.current = basket_list

                // Invest More basket list (separate source from basket_data).
                // The list uses `name` for the basket title (basket_data uses
                // goal_name) — fall back across both so the name renders.
                const invest_more_list = (Array.isArray(response.data?.invest_more) ? response.data.invest_more : []).map((item) => ({
                    ...item,
                    basket: item.goal_name ?? item.name ?? item.basket_name ?? "",
                    allocation: 0,
                    amount: "",
                    id: item.id,
                }));
                investMoreData.current = invest_more_list;
                setHasBasketInvestMore(invest_more_list.length > 0);

                let finalData = basket_list;

                if (investType === INVEST_TYPE.STP) {
                    finalData = basket_list.filter(item => item.stp_enable === true);
                } else if (investType === INVEST_TYPE.INVEST_MORE) {
                    finalData = invest_more_list;
                }

                setAllocationData(finalData);
                const firstItem = response.data.basket_data[0];

                if (stpChecked) {
                    setStpFrequency({ label: 'Daily', value: 1 });
                } else {
                    setStpFrequency(null)
                }

                if (Number(amount) > 0 && firstItem.daily_minimum_installment > 0) {
                    setStpAmount((amount / firstItem.daily_minimum_installment).toFixed(2));
                }
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
        })
    };


    // ── STP HANDLERS ──

    function _handleStpWithdrawalCountChange(value, frequency) {
        const cleaned = value === '' ? '' : String(parseInt(value, 10) || '');
        const count = parseInt(cleaned) || '';
        setStpWithdrawalCount(count);

        if (count > 0 && amount > 0) {
            setStpAmount((amount / count).toFixed(2));
        } else {
            setStpAmount('');
        }
    }

    function _handleStpAmountChange(value, frequency) {
        setStpAmount(value);

        if (value) {
            if (frequency?.value === 1) {
                const days = Math.floor(amount / value);
                setStpWithdrawalCount(days);
            }

            if (frequency?.value === 2) {
                const weeks = Math.floor(amount / value);
                setStpWithdrawalCount(weeks);
            }
        } else {
            setStpWithdrawalCount(0);
        }
    }

    // API - get basket data
    const _getFilterData = (id, is_first) => {
        const url = devconfig.admin + "/basket-order/schedule-filter";
        APIGet(url).then((response) => {
            if (response.status_code === 200) {
                setFrequencyOptions(response.data.frequency.map((item) => ({
                    label: item.label,
                    value: item.id
                })))
                setDaysOptions(response.data.repeat_day.map((item) => ({
                    label: item.label,
                    value: item.id
                })))
            }
        })
    }
    return (
        <div className="row">
            {
                showDetail ?
                    <div className="col-12">

                        <span className="e-breadcrumb-link"><span onClick={() => navigate(-1)} className="cursor-pointer">Orders</span>/Create cart order</span>
                        <div className="card e-dashboard-card border-0 mt-2 h-auto p-0">
                            <div className="row p-3 ps-3">
                                <div className="col-lg-5 col-6 pe-0">
                                    <div className="d-flex gap-4 align-items-center">
                                        <div className="e-profile-icon">{detail.short_name}</div>
                                        <span className="e-profile-name">{detail.name}</span>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="e-info p-4">
                                        <div className="row">
                                            <div className="col-4">
                                                <h6>Cust.ID</h6>
                                                <p>{detail.mira_customer_id}</p>
                                            </div>
                                            <div className="col-4">
                                                <h6>Joined on</h6>
                                                <p>{detail.joined_on}</p>
                                            </div>
                                            <div className="col-4">
                                                <h6>Phone</h6>
                                                <p>{detail.mobile}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card e-dashboard-card border-0 mt-3 h-auto">
                            <div className="d-flex justify-content-between align-items-end">
                                <div className="d-flex align-items-end e-type-sec">
                                    <h6
                                        className={activeOrderTab === ORDER_TAB.BASKET ? "e-active-tab mb-0 me-4" : "e-tab mb-0 me-4"}
                                        onClick={() => setActiveOrderTab(ORDER_TAB.BASKET)}
                                    >
                                        Basket & Allocation
                                    </h6>
                                    <h6
                                        className={activeOrderTab === ORDER_TAB.AMS ? "e-active-tab mb-0 me-4" : "e-tab mb-0 me-4"}
                                        onClick={() => setActiveOrderTab(ORDER_TAB.AMS)}
                                    >
                                        AMS & Allocation
                                    </h6>
                                </div>
                                <div className="d-flex align-items-center gap-2 cursor-pointer" onClick={_handleBack}>
                                    <img
                                        src={require("../../assets/images/navigation/back.svg").default}
                                        alt="back"
                                    />
                                </div>
                            </div>
                            <div className="e-create-cart mt-3 p-3">

                                <div className="row align-items-center">
                                    <div className="col-3">
                                        <h6 className="e-font-14 mb-1">Investment amount </h6>
                                        <AmountInput defaultValue={amount}
                                            placeholder='Enter Amount'
                                            // wrapperClass={`${sipChecked === false ? "opacity-0" : ""}`}
                                            valueChange={(input_value) => {
                                                _handleAmount(input_value)
                                            }} />
                                    </div>
                                    {activeOrderTab === ORDER_TAB.BASKET && (selectedBaskets.length > 0 || addedFunds.length > 0) && <div className="col-2 pt-3">
                                        <TextBtn name="Clear All"
                                            handleClick={_clearAll} />
                                    </div>}
                                    {activeOrderTab === ORDER_TAB.AMS && selectedAMS.length > 0 && <div className="col-2 pt-3">
                                        <TextBtn name="Clear All"
                                            handleClick={_clearAll} />
                                    </div>}
                                    <div className="col-12 ">
                                        <div className="d-flex   gap-4">
                                            <div className="pt-2">
                                                <h6 className="e-font-14 mb-1 mt-3">Invest  type </h6>
                                                <div className="d-flex align-items-start gap-md-4 gap-2">
                                                    {/* <div className="d-flex align-items-center gap-2 cursor-pointer" onClick={() => {
                                                _handleChecked(false)

                                            }}>
                                                <Input type="radio"
                                                    id="e-select"
                                                    className="cursor-pointer"
                                                    checked={sipChecked === false}
                                                    valueChange={() => {
                                                        _handleChecked(false)
                                                    }} />
                                                <span className="e-font-14 color-grey e-poppins-regular">Lumpsum</span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2 cursor-pointer " onClick={() => {
                                                _handleChecked(true)
                                            }}>
                                                <Input type="radio"
                                                    id="e-select"
                                                    className="cursor-pointer"
                                                    checked={sipChecked === true}
                                                    valueChange={() => {
                                                        _handleChecked(true)
                                                    }} />
                                                <span className="e-font-14 color-grey e-poppins-regular">SIP</span>
                                            </div>

                                            <div className="d-flex align-items-center gap-2 cursor-pointer " onClick={() => {
                                                _handleChecked(true)
                                            }}>
                                                <Input type="radio"
                                                    id="e-select"
                                                    className="cursor-pointer"
                                                    checked={stpChecked === true}
                                                    valueChange={() => {
                                                        _handleChecked(true)
                                                    }} />
                                                <span className="e-font-14 color-grey e-poppins-regular">STP</span>
                                            </div> */}

                                                    <div className="d-flex flex-column">
                                                        <div
                                                            className="d-flex align-items-center gap-2 cursor-pointer"
                                                            onClick={() => _handleChecked(INVEST_TYPE.LUMPSUM)}
                                                        >
                                                            <Input
                                                                type="radio"
                                                                checked={investType === INVEST_TYPE.LUMPSUM}
                                                                valueChange={() => _handleChecked(INVEST_TYPE.LUMPSUM)}
                                                            />
                                                            <span className="e-font-14 color-grey e-poppins-regular">Lumpsum</span>
                                                        </div>
                                                    </div>

                                                    <div className="d-flex flex-column">
                                                        <div
                                                            className="d-flex align-items-center gap-2 cursor-pointer"
                                                            onClick={() => _handleChecked(INVEST_TYPE.SIP)}
                                                        >
                                                            <Input
                                                                type="radio"
                                                                checked={investType === INVEST_TYPE.SIP}
                                                                valueChange={() => _handleChecked(INVEST_TYPE.SIP)}
                                                            />
                                                            <span className="e-font-14 color-grey e-poppins-regular">SIP</span>
                                                        </div>

                                                    </div>

                                                    {((activeOrderTab === ORDER_TAB.BASKET && hasBasketInvestMore)
                                                        || (activeOrderTab === ORDER_TAB.AMS && hasAmsInvestMore)) && (
                                                    <div className="d-flex flex-column">
                                                        <div
                                                            className="d-flex align-items-center gap-2 cursor-pointer"
                                                            onClick={() => _handleChecked(INVEST_TYPE.INVEST_MORE)}
                                                        >
                                                            <Input
                                                                type="radio"
                                                                checked={investType === INVEST_TYPE.INVEST_MORE}
                                                                valueChange={() => _handleChecked(INVEST_TYPE.INVEST_MORE)}
                                                            />
                                                            <span className="e-font-14 color-grey e-poppins-regular">Invest More</span>
                                                        </div>
                                                    </div>
                                                    )}

                                                    {activeOrderTab === ORDER_TAB.BASKET && (
                                                        <div className="d-flex flex-column">
                                                            <div
                                                                className="d-flex align-items-center gap-2 cursor-pointer"
                                                                onClick={() => _handleChecked(INVEST_TYPE.STP)}
                                                            >
                                                                <Input
                                                                    type="radio"
                                                                    checked={investType === INVEST_TYPE.STP}
                                                                    valueChange={() => _handleChecked(INVEST_TYPE.STP)}
                                                                />
                                                                <span className="e-font-14 color-grey e-poppins-regular">STP</span>
                                                            </div>

                                                        </div>
                                                    )}


                                                </div>
                                            </div>

                                            {sipChecked &&
                                                <div className=" pt-2  ps-4">
                                                    <h6 className="e-font-14 mb-2 mt-3">Pay for first investment now?</h6>

                                                    <div className="d-flex align-items-center gap-3">
                                                        <div className="d-flex align-items-center cursor-pointer">
                                                            <Input
                                                                type="radio"
                                                                checked={firstInvestmentNow === true}
                                                                valueChange={() => setFirstInvestmentNow(true)}
                                                            />
                                                            <span className="ms-2">Yes</span>
                                                        </div>

                                                        <div className="d-flex align-items-center cursor-pointer">
                                                            <Input
                                                                type="radio"
                                                                checked={firstInvestmentNow === false}
                                                                valueChange={() => setFirstInvestmentNow(false)}
                                                            />
                                                            <span className="ms-2">No</span>
                                                        </div>
                                                    </div>

                                                    {/* Contextual helper text */}
                                                    {firstInvestmentNow === true ? (
                                                        <p className="e-font-12 color-grey mt-2 mb-0">
                                                            Your first investment will be done today and first automatic deduction is on{' '}
                                                            <span className="color-primary e-poppins-medium">{_formatSip(selectedDate)}</span>
                                                        </p>
                                                    ) : (
                                                        <p className="e-font-12 color-grey mt-2 mb-0">
                                                            Your first automatic deduction is on{' '}
                                                            <span className="color-primary e-poppins-medium">{_formatSip(selectedDate)}</span>
                                                        </p>
                                                    )}
                                                </div>
                                            }
                                        </div>


                                    </div>



                                    {sipChecked === true && (
                                        <>
                                            <div className="col-3 pt-2">
                                                <h6 className="e-font-14 mb-1">SIP date</h6>
                                                <div
                                                    className={!sipChecked ? "e-sip-date e-sip-date-disabled" : "e-sip-date"}
                                                    onClick={() => _handleDateModal(true)}
                                                >
                                                    {_formatSip(selectedDate)}
                                                    <img
                                                        src={require("../../assets/images/modal/calendar.svg").default}
                                                        alt="calendar"
                                                        className="ms-2"
                                                    />
                                                </div>
                                            </div>
                                            {/* <div className="col-4 pt-2 ps-4">
                                                <h6 className="e-font-14 mb-2">Pay for first investment now?</h6>

                                                <div className="d-flex align-items-center gap-3">
                                                    <div className="d-flex align-items-center cursor-pointer">
                                                        <Input
                                                            type="radio"
                                                            checked={firstInvestmentNow === true}
                                                            valueChange={() => setFirstInvestmentNow(true)}
                                                        />
                                                        <span className="ms-2">Yes</span>
                                                    </div>

                                                    <div className="d-flex align-items-center cursor-pointer">
                                                        <Input
                                                            type="radio"
                                                            checked={firstInvestmentNow === false}
                                                            valueChange={() => setFirstInvestmentNow(false)}
                                                        />
                                                        <span className="ms-2">No</span>
                                                    </div>
                                                </div>
                                            </div> */}

                                        </>
                                    )}
                                </div>
                                <div className={`e-cart-basket-inputs mt-3 ${activeOrderTab === ORDER_TAB.BASKET ? "" : "d-none"}`}>
                                    <div className="row gx-2">
                                        <div className="col-xxl-3 col-xl-4 col-5">
                                            <h6 className="e-section-title">Baskets</h6>
                                        </div>
                                        <div className="col-xxl-1 col-xl-2 col-3">
                                            <h6 className="e-section-title">Allocation</h6>
                                        </div>
                                        <div className="col-1 ps-4">
                                            <h6 className="e-section-title">Amount</h6>
                                        </div>
                                        {!isInvestMore && (
                                            <div className="col min-w-0 ps-5">
                                                <h6 className="e-section-title mb-0">Message</h6>
                                            </div>
                                        )}
                                    </div>
                                    {
                                        allocationData.map((item, index) => {

                                            const isBasketDisabled = _isBasketDisabled(item);
                                            const disabledMsg = _getBasketDisabledMsg(item);
                                            const isChecked = selectedBaskets.some((data) => data.id === item.id);


                                            return (
                                                <div className="row gx-2 align-items-center mb-2" key={item.id}>
                                                    <div className="col-xxl-3 col-xl-4 col-5 mb-sm-0 mb-3 pt-1">
                                                        <div className="d-flex gap-3 align-items-center">
                                                            <Input type="checkbox"
                                                                id="e-select"
                                                                className="cursor-pointer"
                                                                disabled={isBasketDisabled}
                                                                // checked={selectedBaskets.some((data) => data.id === item.id)}
                                                                checked={isChecked}
                                                                valueChange={() => !isBasketDisabled && _handleSelect(item, index)} />
                                                            <h6 className={`mb-0 ${isBasketDisabled ? "color-grey" : ""}`}>
                                                                {item.basket}
                                                            </h6>
                                                        </div>

                                                    </div>
                                                    <div className="col-xxl-1 col-xl-2 col-3">
                                                        <Input type="number"
                                                            suffix="%"
                                                            value={item.allocation == 0.00 ? 0 : item.allocation}
                                                            is_zero
                                                            two_decimal
                                                            wrapperClass="position-relative w-100"
                                                            disabled={isBasketDisabled || !isChecked}
                                                            valueChange={(input_value) => _handleAllocation(input_value, item.id, index)} />
                                                    </div>
                                                    <div className="col-auto ps-4">
                                                        <AmountInput
                                                            // placeholder={sipChecked ? `Min: ${item.min_sip_amount.toLocaleString('en-IN')}` : `Min: ${item.min_lumpsum_amount.toLocaleString('en-IN')}`}
                                                            placeholder={`Min: ${getMinAmount(item).toLocaleString('en-IN')}`}
                                                            disabled={isBasketDisabled || !isChecked}
                                                            defaultValue={item.amount}
                                                            className="w-120px"
                                                            is_zero
                                                            valueChange={(input_value) =>
                                                                _handleBasketAmount(input_value, item.id, index, getMinAmount(item))
                                                            } />


                                                        {/* <span className="e-min"> Min: ₹{item.min_lumpsum_amount.toLocaleString('en-IN')}</span> */}

                                                        {/* <div className={`position-relative`}>
                                                                <h6 className="mb-0">{!sipChecked ? "" : item.amount}</h6>
                                                                <AmountInput disabled
                                                                    placeholder={`Min: ${item.min_sip_amount.toLocaleString('en-IN')}`}
                                                                    // disabled={!selectedBaskets.some((data) => data.id === item.id) || sipChecked === false}
                                                                    defaultValue={sipChecked ? item.amount : ""}
                                                                    className="w-120px"
                                                                    is_zero
                                                                    valueChange={(input_value) => _handleSip(input_value, item.id, index, item.min_sip_amount)} />
                                                                <span className="e-min"> Min: ₹{item.min_sip_amount.toLocaleString('en-IN')}</span>
                                                            </div> */}
                                                    </div>
                                                    {!isInvestMore && (
                                                        <div className="col min-w-0 ps-md-2 d-flex align-items-center">
                                                            {isBasketDisabled && disabledMsg ? (
                                                                <p className="e-font-12 color-red mb-0">
                                                                    {disabledMsg}
                                                                </p>
                                                            ) : null}
                                                        </div>
                                                    )}

                                                </div>
                                            )
                                        })
                                    }

                                    {!stpChecked && !isInvestMore &&
                                        <>
                                            <div className="row mt-3">
                                                <div className="col-md-12">
                                                    <h6 className="e-section-title">Custom funds</h6>
                                                </div>

                                            </div>
                                            {
                                                addedFunds.map((item, index) => {
                                                    return (
                                                        <div className="row gx-2 mb-2 align-items-center">
                                                            <div className='col-xxl-3 col-xl-4 col-5 mb-sm-0 mb-3 position-relative' >
                                                                <Input type='text'
                                                                    placeholder="Search for fund"
                                                                    className='mt-0'
                                                                    value={item.scheme_name}
                                                                    valueChange={(value) => {
                                                                        _handleFundSelect(value, index, item.scheme_code, item);
                                                                        if (value.length > 0) {
                                                                            _getFunds(value, index)
                                                                        } else {
                                                                            setShowDropdown(null);
                                                                        }
                                                                    }} />
                                                                {
                                                                    showDropdown === index ?
                                                                        <div className='position-absolute e-cart-search-dropdown' ref={searchRef} style={{ top: "50px" }}>
                                                                            {fundsList.map((fund, key) => {
                                                                                return (
                                                                                    <p key={key} onClick={() => {
                                                                                        _getFundDetail(fund, index)
                                                                                    }}>{fund.scheme_name}</p>
                                                                                )
                                                                            })}
                                                                        </div>
                                                                        :
                                                                        null
                                                                }

                                                            </div>
                                                            <div className="col-xxl-1 col-xl-2 col-3">
                                                                <Input type="number"
                                                                    suffix="%"
                                                                    two_decimal
                                                                    value={item.allocation == 0.00 ? 0 : item.allocation}
                                                                    is_zero
                                                                    wrapperClass="position-relative w-100"
                                                                    disabled={item.scheme_code === "" ? true : false}
                                                                    valueChange={(input_value) => _handleFundAllocation(input_value, index)} />
                                                            </div>
                                                            <div className="col-4 ps-4">
                                                                <div className="d-flex align-items-start gap-4">
                                                                    <div className={`position-relative`}>
                                                                        <AmountInput
                                                                            placeholder={sipChecked ? item.min_sip_investment ? `Min: ${item.min_sip_investment.toLocaleString('en-IN')}` : "Select fund" : item.min_lumpsum_investment ? `Min: ${item.min_lumpsum_investment.toLocaleString('en-IN')}` : "Select fund"}
                                                                            defaultValue={item.amount}
                                                                            is_zero
                                                                            disabled={item.scheme_code === "" ? true : false}
                                                                            className="w-120px"
                                                                            valueChange={(input_value) => _handleFundAmount(input_value, index)} />
                                                                        {/* {item.min_lumpsum_investment && <span className="e-min"> Min: ₹{item.min_lumpsum_investment.toLocaleString('en-IN')}</span>} */}
                                                                    </div>
                                                                    {/* <div className={`position-relative pt-2 ${sipChecked === false ? "d-none" : ""}`}>
                                                                <AmountInput
                                                                    defaultValue={item.amount}
                                                                    is_zero
                                                                    className="w-120px"
                                                                    disabled
                                                                    placeholder={item.min_sip_investment ? `Min: ${item.min_sip_investment.toLocaleString('en-IN')}` : "Select fund"}
                                                                    valueChange={(input_value) => _handleFundSip(input_value, index)} />
                                                                {item.min_sip_investment && <span className="e-min"> Min: ₹{item.min_sip_investment.toLocaleString('en-IN')}</span>}
                                                            </div> */}
                                                                    <img src={require("../../assets/images/manage-content/Delete.svg").default}
                                                                        alt="delete"
                                                                        onClick={() => _handleDelete(index)}
                                                                        className="mt-1 cursor-pointer" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                            <div className="row mt-3">
                                                <div className="col-12">
                                                    <h6 className="e-add-new mb-0 cursor-pointer" onClick={_handleAdd}>
                                                        <img src={AddNew} alt="add" className="pe-1" />
                                                        Add New
                                                    </h6>
                                                </div>
                                            </div>
                                        </>
                                    }

                                </div>
                                <div className={`e-cart-basket-inputs mt-3 ${activeOrderTab === ORDER_TAB.AMS ? "" : "d-none"}`}>
                                    <div className="row gx-2">
                                        <div className="col-xxl-3 col-xl-4 col-5">
                                            <h6 className="e-section-title">AMS</h6>
                                        </div>
                                        <div className="col-xxl-1 col-xl-2 col-3">
                                            <h6 className="e-section-title">Allocation</h6>
                                        </div>
                                        <div className="col-1 ps-4">
                                            <h6 className="e-section-title">Amount</h6>
                                        </div>
                                        {!isInvestMore && <div className="col min-w-0 ps-5" />}
                                    </div>

                                    {amsAllocationData.map((item, index) => {
                                        const isChecked = selectedAMS.some((data) => data.id === item.id);
                                        return (
                                            <div className="row gx-2 align-items-center mb-2" key={item.id}>
                                                <div className="col-xxl-3 col-xl-4 col-5 mb-sm-0 mb-3 pt-1">
                                                    <div className="d-flex gap-3 align-items-center">
                                                        <Input
                                                            type="checkbox"
                                                            id="e-select"
                                                            className="cursor-pointer"
                                                            checked={isChecked}
                                                            valueChange={() => _handleSelectAMS(item, index)}
                                                        />
                                                        <h6 className="mb-0">{item.ams}</h6>
                                                    </div>
                                                </div>
                                                <div className="col-xxl-1 col-xl-2 col-3">
                                                    <Input
                                                        type="number"
                                                        suffix="%"
                                                        value={item.allocation == 0.00 ? 0 : item.allocation}
                                                        is_zero
                                                        two_decimal
                                                        wrapperClass="position-relative w-100"
                                                        disabled={!isChecked}
                                                        valueChange={(input_value) => _handleAMSAllocation(input_value, item.id, index)}
                                                    />
                                                </div>
                                                <div className="col-auto ps-4">
                                                    <AmountInput
                                                        placeholder={`Min: ${getAMSMinAmount(item).toLocaleString('en-IN')}`}
                                                        disabled={!isChecked}
                                                        defaultValue={item.amount}
                                                        className="w-120px"
                                                        is_zero
                                                        valueChange={(input_value) => _handleAMSAmount(input_value, item.id, index)}
                                                    />
                                                </div>
                                                {!isInvestMore && <div className="col min-w-0 ps-md-2 d-flex align-items-center" />}
                                            </div>
                                        );
                                    })}
                                    <div className="row mt-3">
                                        <div className="col-12">
                                            <h6 className="e-add-new mb-0 cursor-pointer" onClick={_openCreateAMSModal}>
                                                <img src={AddNew} alt="add" className="pe-1" />
                                                Add new AMS
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                                <div className={activeOrderTab === ORDER_TAB.BASKET ? "" : "d-none"}>
                                <div className="row pt-3 ps-3">
                                    <div className="col-xxl-3 col-xl-4 col-5">
                                        <h6 className="e-section-title">Total allocation</h6>
                                    </div>
                                    <div className="col-xxl-1 col-xl-2 col-3">
                                        <h6 className="e-section-title">{(_getTotalAllocation()).toFixed(2)}%</h6>
                                    </div>
                                    <div className="col-4 ps-4">
                                        <h6 className="e-section-title ps-2">₹{_getTotalAmount(1)}</h6>
                                    </div>
                                </div>
                                </div>
                                <div className={activeOrderTab === ORDER_TAB.AMS ? "" : "d-none"}>
                                    <div className="row pt-3 ps-3">
                                        <div className="col-xxl-3 col-xl-4 col-5">
                                            <h6 className="e-section-title">Total allocation</h6>
                                        </div>
                                        <div className="col-xxl-1 col-xl-2 col-3">
                                            <h6 className="e-section-title">{(_getAMSTotalAllocation()).toFixed(2)}%</h6>
                                        </div>
                                        <div className="col-4 ps-4">
                                            <h6 className="e-section-title ps-2">₹{_getAMSTotalAmount(1)}</h6>
                                        </div>
                                    </div>
                                </div>
                            <div>
                            {
                                investType === INVEST_TYPE.LUMPSUM ?
                                    <div className="row">
                                        <div className="col-12">
                                            <h6
                                                className="e-schedule-title mb-3 cursor-pointer d-inline-block"
                                                onClick={() => setScheduleExpanded((prev) => !prev)}
                                                role="button"
                                                tabIndex={0}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter" || e.key === " ") {
                                                        e.preventDefault();
                                                        setScheduleExpanded((prev) => !prev);
                                                    }
                                                }}
                                            >
                                                <i
                                                    aria-hidden="true"
                                                    style={{
                                                        display: "inline-block",
                                                        marginRight: "8px",
                                                        transition: "transform 0.2s ease",
                                                        transform: scheduleExpanded ? "rotate(90deg)" : "rotate(0deg)",
                                                        fontSize: "10px",
                                                        fontStyle: "normal",
                                                        verticalAlign: "middle",
                                                        color: "#6D6D6D",
                                                    }}
                                                >
                                                    ▶
                                                </i>
                                                Schedule for later <span>(optional)</span>
                                            </h6>
                                        </div>
                                        <div className={`col-12 ${scheduleExpanded ? "" : "d-none"}`}>
                                            <div className="e-scheduled-order py-4 px-3 position-relative">
                                                <img src={require("../../assets/images/cta/clear.png").default}
                                                    alt="Clear"
                                                    onClick={() => {
                                                        setStartDate(null);
                                                        setEndDate(null);
                                                        setNext30(false);
                                                        setSelectedFrequency(null);
                                                        setRepeatedDay(null)
                                                    }}
                                                    className="position-absolute e-clear-scheduled" />
                                                <div className="row">
                                                    <div className="col-lg-3 col-sm-6 col-12">
                                                        <label>Start date</label>
                                                        <Datepicker placeholder="Select start date"
                                                            value={startDate}
                                                            disabledDate={disabledDate}
                                                            onChange={(value) => {
                                                                setStartDate(value)
                                                            }} />
                                                    </div>
                                                    <div className="col-lg-3 col-sm-6 col-12">
                                                        <label>End date</label>
                                                        <Datepicker
                                                            placeholder="Select end date"
                                                            value={endDate}
                                                            disabledDate={disabledDate}
                                                            onChange={(value) => {
                                                                setEndDate(value)
                                                            }} />
                                                        <div className="d-flex align-items-center gap-2 mt-2">
                                                            <Input type="checkbox"
                                                                id="e-select"
                                                                className="cursor-pointer"
                                                                checked={next30}
                                                                valueChange={() => {
                                                                    setNext30(!next30)
                                                                    if (!next30) {
                                                                        const tomorrow = moment().add(1, 'day').startOf('day');
                                                                        setStartDate(tomorrow.format("DD-MM-YYYY"));
                                                                        setEndDate((tomorrow.clone().add(30, 'years')).format("DD-MM-YYYY"));
                                                                    } else {
                                                                        setStartDate(null);
                                                                        setEndDate(null);
                                                                    }
                                                                }} />
                                                            <label className="mb-0 e-thirty-label pt-1">For next 30 years</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3 col-sm-6 col-12">
                                                        <label>Repeat Frequency</label>
                                                        <SelectBox options={frequencyOptions}
                                                            value={selectedFrequency}
                                                            isSearchable={false}
                                                            placeholder="Select Repeat Frequency"
                                                            selectchange={(value) => setSelectedFrequency(value)} />

                                                    </div>
                                                    {
                                                        (selectedFrequency?.value === 3 || selectedFrequency?.value === 2) ?
                                                            <div className="col-lg-3 col-sm-6 col-12 position-relative">
                                                                <label>Frequency</label>
                                                                <div onClick={() => setShowDropdown(true)}>
                                                                    <SelectBox isDisabled
                                                                        value={repeatedDay}
                                                                        placeholder="Select Day"
                                                                        isSearchable={false}
                                                                        className=''
                                                                    />
                                                                </div>
                                                                {
                                                                    showDropdown ?
                                                                        <div className='position-absolute e-cart-search-dropdown' ref={searchRef} style={{ top: "75px", left: "-10px", height: "max-content", overflowY: "hidden" }}>
                                                                            {daysOptions.map((item, index) => {
                                                                                return (
                                                                                    <p key={index} onClick={() => {
                                                                                        setRepeatedDay(item)
                                                                                        setShowDropdown(false)
                                                                                    }}>{item.label}</p>
                                                                                )
                                                                            })}
                                                                            {selectedFrequency?.value === 3 && <div className="e-info-container d-flex mt-3 p-2 align-items-start gap-2">
                                                                                <img src={require("../../assets/images/cta/information-filled.svg").default} />
                                                                                We’ll repeat this every 14 days from the selected date. If the date falls on a non-market day (weekend or holiday), the investment will be processed on the next available market day.
                                                                            </div>}
                                                                        </div>
                                                                        :
                                                                        null
                                                                }
                                                            </div>
                                                            :
                                                            selectedFrequency?.value === 4 ?
                                                                <div className="col-lg-3 col-sm-6 col-12 position-relative">
                                                                    <label>Frequency</label>
                                                                    <div className="cursor-pointer" onClick={() => setShowDropdown(true)}>
                                                                        <SelectBox isDisabled
                                                                            value={repeatedDate}
                                                                            isSearchable={false}
                                                                            placeholder="Select Day"
                                                                            className=''
                                                                        />
                                                                    </div>
                                                                    {
                                                                        showDropdown ?
                                                                            <div className='position-absolute e-date-dropdown p-3' ref={searchRef} >
                                                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                                                    <h6>Select date</h6>
                                                                                    <button id="close-sip"
                                                                                        type="button"
                                                                                        className="btn-close"
                                                                                        data-bs-dismiss="modal"
                                                                                        onClick={() => setShowDropdown(false)} >
                                                                                    </button>
                                                                                </div>

                                                                                <div className="d-flex flex-wrap text-center">
                                                                                    {NORMALIZED_SIP_DATES.map((item, key) => (
                                                                                        <div className={` d-flex align-items-center justify-content-center e-cart-date ${selectedRepeatedDate === item ? "e-active-date" : "e-cart-date color-eerie-black cursor-pointer"}`}
                                                                                            key={key}
                                                                                            onClick={() => {
                                                                                                setSelectedRepeatedDate(item)
                                                                                            }} >
                                                                                            {item}
                                                                                        </div>
                                                                                    ))}

                                                                                </div>


                                                                                <div className="e-info-container d-flex  p-2 align-items-start gap-2">
                                                                                    <img src={require("../../assets/images/cta/information-filled.svg").default} />
                                                                                    We’ll repeat this every 14 days from the selected date. If the date falls on a non-market day (weekend or holiday), the investment will be processed on the next available market day.
                                                                                </div>
                                                                                <div className='mt-3 col-12 mx-auto'>
                                                                                    <PrimaryBtn name="Confirm date"
                                                                                        className="padding-10px-tb w-100 color"
                                                                                        handleClick={() => {
                                                                                            setRepeatedDate({
                                                                                                label: _formatSip(selectedRepeatedDate),
                                                                                                value: selectedRepeatedDate
                                                                                            })
                                                                                            setShowDropdown(false)
                                                                                        }} />
                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            null
                                                                    }
                                                                </div>
                                                                :
                                                                null
                                                    }
                                                    <div className="col-lg-12 pt-3">
                                                        <div className="e-info-container d-flex e-font-12 py-3 px-4 align-items-center gap-2">
                                                            <img src={require("../../assets/images/cta/information-filled.svg").default} width={20} />
                                                            User cart will display the available funds as per the schedule set by the you. The start date, end date, and frequency determine which funds are visible during this period.                                                      </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    null
                            }

                            {activeOrderTab === ORDER_TAB.BASKET && investType === INVEST_TYPE.STP &&
                                <div className="row">
                                    <div className="col-12">
                                        <h6 className="e-schedule-title mb-3">Setup Recurring Order </h6>
                                    </div>
                                    <div className="col-12">
                                        <div className="e-scheduled-order py-4 px-3 position-relative">
                                            <img src={require("../../assets/images/cta/clear.png").default}
                                                alt="Clear"
                                                onClick={() => {
                                                    setStpAmount('');
                                                    setStpWithdrawalCount(0);
                                                    setStpFrequency(null);
                                                    setStpRepeatDay(null);
                                                }}
                                                className="position-absolute e-clear-scheduled" />

                                            <div className="row">

                                                {/* Repeat Frequency — always visible */}
                                                <div className="col-lg-3 col-sm-6 col-12">
                                                    <label>Repeat Frequency</label>
                                                    <SelectBox
                                                        options={stpFrequencyOptions}
                                                        value={stpFrequency}
                                                        isSearchable={false}
                                                        placeholder="Select frequency"
                                                        selectchange={(value) => {
                                                            setStpFrequency(value);
                                                            setStpRepeatDay(null);

                                                            // reset
                                                            // setStpAmount('');
                                                            setStpWithdrawalCount(0);

                                                            if (value?.value === 1) {
                                                                // DAILY
                                                                const minDays = allocationData.length
                                                                    ? Math.max(...allocationData.map(item => item.daily_minimum_installment || 0))
                                                                    : 0;

                                                                setStpWithdrawalCount(minDays);

                                                                if (amount > 0 && minDays > 0) {
                                                                    setStpAmount((amount / minDays).toFixed(2));
                                                                }
                                                            }

                                                            if (value?.value === 2) {
                                                                //  WEEKLY
                                                                const minWeeks = allocationData.length
                                                                    ? Math.max(...allocationData.map(item => item.weekly_minimum_installment || 0))
                                                                    : 0;

                                                                setStpWithdrawalCount(minWeeks);

                                                                if (amount > 0) {
                                                                    if (stpAmount > 0) {
                                                                        setStpWithdrawalCount(Math.floor(amount / stpAmount));
                                                                    } else {
                                                                        setStpWithdrawalCount(minWeeks);
                                                                        setStpAmount((amount / minWeeks).toFixed(2));
                                                                    }
                                                                } else {
                                                                    setStpWithdrawalCount(minWeeks);
                                                                }


                                                            }
                                                        }} />
                                                </div>

                                                {/* DAILY only */}
                                                {stpFrequency?.value === 1 &&
                                                    <>
                                                        <div className="col-lg-3 col-sm-6 col-12">
                                                            <label>Withdrawal Config-No of Days</label>
                                                            <Input
                                                                type="number"
                                                                placeholder="Enter no of days "
                                                                suffix="Days"
                                                                value={stpWithdrawalCount}
                                                                valueChange={(value) => _handleStpWithdrawalCountChange(value, stpFrequency)} />
                                                        </div>
                                                        <div className="col-auto d-flex align-items-center pt-4">
                                                            <span style={{ color: '#106ee8' }} className="color-primary e-font-14">or</span>
                                                        </div>
                                                        <div className="col-lg-3 col-sm-6 col-12">
                                                            <label className="color-primary">Withdrawal Config-Daily amount</label>
                                                            <AmountInput
                                                                placeholder={selectedStpMinAmount > 0 ? `Min ₹${selectedStpMinAmount}` : "Amount"}
                                                                suffix={selectedStpMinAmount > 0 ? `Min ₹${selectedStpMinAmount}` : ""}
                                                                suffixClassName="color-primary"
                                                                defaultValue={stpAmount}
                                                                valueChange={(value) => _handleStpAmountChange(value, stpFrequency)} />
                                                        </div>
                                                    </>
                                                }

                                                {/* WEEKLY only */}
                                                {stpFrequency?.value === 2 &&
                                                    <>
                                                        <div className="col-lg-3 col-sm-6 col-12">
                                                            <label>Repeat</label>
                                                            <SelectBox
                                                                options={stpRepeatDayOptions}
                                                                value={stpRepeatDay}
                                                                isSearchable={false}
                                                                placeholder="Select day"
                                                                selectchange={(value) => setStpRepeatDay(value)} />
                                                        </div>
                                                        <div className="col-lg-3 col-sm-6 col-12">
                                                            <label>Withdrawal-No of Week</label>
                                                            <Input
                                                                type="number"
                                                                placeholder="0"
                                                                suffix="Weeks"
                                                                value={stpWithdrawalCount}
                                                                valueChange={(value) => _handleStpWithdrawalCountChange(value, stpFrequency)} />
                                                        </div>
                                                        <div className="col-lg-3 col-sm-6 col-12">
                                                            <label className="color-primary">Withdrawal-Weekly amount</label>
                                                            <AmountInput
                                                                placeholder={selectedStpMinAmount > 0 ? `Min ₹${selectedStpMinAmount}` : "Amount"}
                                                                suffix={selectedStpMinAmount > 0 ? `Min ₹${selectedStpMinAmount}` : ""}
                                                                suffixClassName="color-primary"
                                                                defaultValue={stpAmount}
                                                                valueChange={(value) => _handleStpAmountChange(value, stpFrequency)} />
                                                        </div>
                                                    </>
                                                }

                                                {/* Info banner — only when frequency is selected */}
                                                {stpFrequency !== null &&
                                                    <div className="col-lg-12 pt-3">
                                                        <div className="e-info-container d-flex e-font-12 py-3 px-4 align-items-center gap-2">
                                                            <img src={require("../../assets/images/cta/information-filled.svg").default} width={20} />
                                                            {stpFrequency?.value === 1
                                                                ? "Enter the number of days or the daily amount. The system will automatically calculate the corresponding value based on the selected frequency."
                                                                : "Enter the number of weeks or the weekly amount. The system will automatically calculate the corresponding value based on the selected frequency."
                                                            }
                                                        </div>
                                                    </div>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            </div>

                            <div className="row pb-3 pt-4 mt-3">
                                <div className="col-3">
                                    <PrimaryBtn name="Send to User"
                                        className={(activeOrderTab === ORDER_TAB.BASKET
                                            ? (selectedBaskets.length === 0 && addedFunds.length === 0)
                                            : (selectedAMS.length === 0)
                                        ) ? "e-disabled" : btnLoader === true ? "e-disabled e-btn-loader" : ""}
                                        handleClick={_handleSubmit} />
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    :
                    <div className="col-lg-12  h-100vh">
                        <div className="card e-dashboard-card border-0 py-1">
                            <div className="col-lg-12 pt-2">
                                <h6 className="e-section-title mb-0">
                                    Create cart order
                                </h6>
                            </div>
                            <div className='col-lg-3 position-relative pt-4' >
                                <div onClick={() => _getCustomerFilterData(search)}>
                                    <label className="mb-0">Search & select user</label>
                                    <Input type='text'
                                        placeholder="Search for customer"
                                        className='py-2 e-cart-input mt-0'
                                        value={selectedCustomer !== null ? selectedCustomer.label : search}
                                        valueChange={(value) => {
                                            setSearch(value);
                                            _getCustomerFilterData(value)
                                        }} />
                                </div>
                                {
                                    showDropdown ?
                                        <div className='position-absolute e-cart-search-dropdown' ref={searchRef}>
                                            {customerList.map((item, index) => {
                                                return (
                                                    <p key={index} onClick={() => {
                                                        _selectCustomer(item)
                                                    }}>{item.label}</p>
                                                )
                                            })}
                                        </div>
                                        :
                                        null
                                }

                            </div>
                        </div>
                    </div>
            }

            <ToastContainer position="bottom-center" autoClose={false} />
            {
                (showDateModal === true) &&
                <Fragment>
                    <SIPDateModal apiDates={[]}
                        selectedSIPDate={selectedDate}
                        handleSelect={_handleSelectDate}
                        handleCloseDateModal={() => _handleDateModal(false)} />
                </Fragment>
            }
            {
                (orderSent === true) &&
                <Fragment>
                    <SuccessConfirmationModal closeModal={_handleClose}
                        message={(startDate !== null && endDate !== null && selectedFrequency !== null)
                            ? "Order scheduled"
                            : "Successfully send to investor"}
                        handleNavigate={_viewOrders} />
                </Fragment>
            }
            {
                showAMSFormModal === true &&
                <ManageAMSForm
                    goals={amsGoals}
                    data={null}
                    onSubmit={_handleAMSFormSubmit}
                    closeModal={() => setShowAMSFormModal(false)}
                />
            }
        </div >
    )
}

export default CreateCartOrder